import reducer from "../reducerGenerator";

import * as actionTypes from "./actionTypes";
import * as reducerActions from "./reducerActions";

const initialState = {
  loading: false,
  error: false,
  success: false,
};

const mapper = {
  [actionTypes.SHOW_TEST_DRIVE_LOADER]: reducerActions.showLoader,
  [actionTypes.HIDE_TEST_DRIVE_LOADER]: reducerActions.hideLoader,
  [actionTypes.TEST_DRIVE_SENT]: reducerActions.testDriveSent,
  [actionTypes.TEST_DRIVE_SEND_FAILED]: reducerActions.testDriveSendFailed,
};

export default reducer(mapper, initialState);



// WEBPACK FOOTER //
// ./src/store/testDrives/reducer.js